import { animate, state, style, transition, trigger } from '@angular/animations';
import { effect, ElementRef, input, signal } from '@angular/core';
import { LayoutSidebarService } from './sidebar.service';
import { NgClass } from '@angular/common';
import { UiIconComponent } from '@common/ui/frontend-shared/icons';
import { RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { UiRouterLinkActivePathDirective } from '@common/ui/frontend-shared/router-link-active-path';
import * as i0 from "@angular/core";
import * as i1 from "./sidebar.service";
const _c0 = ["layout-sidebar-menu", ""];
const _c1 = () => ({
  isActive: "active-menuitem"
});
const _c2 = () => ({
  isInActivePath: "active-path"
});
function LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 4);
  }
  if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", child_r3.icon)("size", ctx_r4.root() ? "lg" : "md");
  }
}
function LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 5);
  }
}
function LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 6);
  }
  if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("icon", child_r3.icon)("size", "md");
  }
}
function LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵlistener("click", function LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_1_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      const child_r3 = ctx_r1.$implicit;
      const ɵ$index_1_r4 = ctx_r1.$index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.itemClick($event, child_r3, ɵ$index_1_r4));
    });
    i0.ɵɵconditionalCreate(1, LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_1_Conditional_1_Template, 1, 2, "ui-icon", 4);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(4, LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_1_Conditional_4_Template, 1, 0, "i", 5);
    i0.ɵɵconditionalCreate(5, LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_1_Conditional_5_Template, 1, 2, "ui-icon", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", child_r3.url || "#", i0.ɵɵsanitizeUrl)("ngClass", child_r3.styleClass);
    i0.ɵɵattribute("tabindex", !ctx_r4.visible() ? "-1" : null)("target", child_r3.target);
    i0.ɵɵadvance();
    i0.ɵɵconditional(child_r3.icon ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(child_r3.label);
    i0.ɵɵadvance();
    i0.ɵɵconditional(child_r3.items ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r4.root() && child_r3.icon ? 5 : -1);
  }
}
function LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 4);
  }
  if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", child_r3.icon)("size", ctx_r4.root() ? "lg" : "md");
  }
}
function LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 5);
  }
}
function LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 6);
  }
  if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("icon", child_r3.icon)("size", "md");
  }
}
function LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵlistener("click", function LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_2_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      const child_r3 = ctx_r1.$implicit;
      const ɵ$index_1_r4 = ctx_r1.$index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.itemClick($event, child_r3, ɵ$index_1_r4));
    });
    i0.ɵɵconditionalCreate(1, LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_2_Conditional_1_Template, 1, 2, "ui-icon", 4);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(4, LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_2_Conditional_4_Template, 1, 0, "i", 5);
    i0.ɵɵconditionalCreate(5, LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_2_Conditional_5_Template, 1, 2, "ui-icon", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", child_r3.routerLink)("routerLinkActivePath", i0.ɵɵpureFunction0(8, _c1));
    i0.ɵɵattribute("tabindex", !ctx_r4.visible() ? "-1" : null)("target", child_r3.target);
    i0.ɵɵadvance();
    i0.ɵɵconditional(child_r3.icon ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(child_r3.label);
    i0.ɵɵadvance();
    i0.ɵɵconditional(child_r3.items ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r4.root() && child_r3.icon ? 5 : -1);
  }
}
function LayoutSidebarMenuComponent_For_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵconditionalCreate(1, LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_1_Template, 6, 8, "a", 1);
    i0.ɵɵconditionalCreate(2, LayoutSidebarMenuComponent_For_1_Conditional_0_Conditional_2_Template, 6, 9, "a", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(child_r3.badgeStyleClass + " menuitem");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!child_r3.routerLink ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(child_r3.routerLink ? 2 : -1);
  }
}
function LayoutSidebarMenuComponent_For_1_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 4);
  }
  if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", child_r3.icon)("size", ctx_r4.root() ? "lg" : "md");
  }
}
function LayoutSidebarMenuComponent_For_1_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 5);
  }
}
function LayoutSidebarMenuComponent_For_1_Conditional_1_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 6);
  }
  if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("icon", child_r3.icon)("size", "md");
  }
}
function LayoutSidebarMenuComponent_For_1_Conditional_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ul", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const child_r3 = ctx_r1.$implicit;
    const ɵ$index_1_r4 = ctx_r1.$index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("item", child_r3)("visible", ctx_r4.isToggled(ɵ$index_1_r4))("reset", ctx_r4.reset())("parentActive", ctx_r4.isToggled(ɵ$index_1_r4))("@children", ctx_r4.isToggled(ɵ$index_1_r4) ? "visibleAnimated" : "hiddenAnimated")("root", false);
  }
}
function LayoutSidebarMenuComponent_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 8);
    i0.ɵɵlistener("click", function LayoutSidebarMenuComponent_For_1_Conditional_1_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      const child_r3 = ctx_r1.$implicit;
      const ɵ$index_1_r4 = ctx_r1.$index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.itemClick($event, child_r3, ɵ$index_1_r4));
    })("routerLinkActiveState", function LayoutSidebarMenuComponent_For_1_Conditional_1_Template_a_routerLinkActiveState_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ɵ$index_1_r4 = i0.ɵɵnextContext().$index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.setToggled($event, ɵ$index_1_r4));
    });
    i0.ɵɵconditionalCreate(2, LayoutSidebarMenuComponent_For_1_Conditional_1_Conditional_2_Template, 1, 2, "ui-icon", 4);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(5, LayoutSidebarMenuComponent_For_1_Conditional_1_Conditional_5_Template, 1, 0, "i", 5);
    i0.ɵɵconditionalCreate(6, LayoutSidebarMenuComponent_For_1_Conditional_1_Conditional_6_Template, 1, 2, "ui-icon", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(7, LayoutSidebarMenuComponent_For_1_Conditional_1_Conditional_7_Template, 1, 6, "ul", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(child_r3.badgeStyleClass + " menuitem");
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", child_r3.routerLink)("routerLinkActivePath", ctx_r4.root() ? i0.ɵɵpureFunction0(11, _c2) : i0.ɵɵpureFunction0(12, _c1));
    i0.ɵɵattribute("tabindex", !ctx_r4.visible() ? "-1" : null)("target", child_r3.target);
    i0.ɵɵadvance();
    i0.ɵɵconditional(child_r3.icon ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(child_r3.label);
    i0.ɵɵadvance();
    i0.ɵɵconditional(child_r3.items ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r4.root() && child_r3.icon ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(child_r3.items ? 7 : -1);
  }
}
function LayoutSidebarMenuComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, LayoutSidebarMenuComponent_For_1_Conditional_0_Template, 3, 4, "li", 0);
    i0.ɵɵconditionalCreate(1, LayoutSidebarMenuComponent_For_1_Conditional_1_Template, 8, 13, "li", 0);
  }
  if (rf & 2) {
    const child_r3 = ctx.$implicit;
    i0.ɵɵconditional(child_r3.visible !== false && !child_r3.items ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(child_r3.visible !== false && child_r3.items ? 1 : -1);
  }
}
// https://github.com/angular/angular/issues/8397#issuecomment-240524312
// https://github.com/angular/angular/issues/8397#issuecomment-219401076
export let LayoutSidebarMenuComponent = /*#__PURE__*/(() => {
  class LayoutSidebarMenuComponent {
    constructor(sidebarService, element) {
      this.sidebarService = sidebarService;
      this.element = element;
      this.item = input(...(ngDevMode ? [undefined, {
        debugName: "item"
      }] : /* istanbul ignore next */[]));
      this.root = input(true, ...(ngDevMode ? [{
        debugName: "root"
      }] : /* istanbul ignore next */[]));
      this.visible = input.required(...(ngDevMode ? [{
        debugName: "visible"
      }] : /* istanbul ignore next */[]));
      this.expandAll = input(false, ...(ngDevMode ? [{
        debugName: "expandAll"
      }] : /* istanbul ignore next */[]));
      this.reset = input(false, ...(ngDevMode ? [{
        debugName: "reset"
      }] : /* istanbul ignore next */[]));
      this.parentActive = input(false, ...(ngDevMode ? [{
        debugName: "parentActive"
      }] : /* istanbul ignore next */[]));
      this._parentActive = effect(() => {
        const x = this.parentActive();
        if (!x) this.activeIndex.set(null);
      }, ...(ngDevMode ? [{
        debugName: "_parentActive"
      }] : /* istanbul ignore next */[]));
      this.activeIndex = signal(null, ...(ngDevMode ? [{
        debugName: "activeIndex"
      }] : /* istanbul ignore next */[]));
      this.anchored = toSignal(this.sidebarService.anchored$);
      this.hoveringMenu = toSignal(this.sidebarService.hoveringMenuWithDelayedHide$);
      this.sidebarService.enableSidebar(true);
    }
    itemClick(event, item, index) {
      if (this.root()) {
        this.sidebarService.toggleMenuHovering();
      }
      // avoid processing disabled items
      if (item.disabled) {
        event.preventDefault();
        return true;
      }
      // update expanded menuItem index
      // if set to null, all menuItems will collapse.
      // we dont want that so we dont do anything when clicking the already active index.
      if (this.activeIndex() !== index) this.activeIndex.set(index);
      // execute command
      if (item.command) {
        item.command({
          originalEvent: event,
          item: item
        });
      }
      // prevent hash change
      if (item.items || !item.url && !item.routerLink) {
        setTimeout(() => {
          this.sidebarService.moveMenuScrollerBar();
        }, 450);
        event.preventDefault();
      }
      // hide menu
      if (!item.items) {
        this.sidebarService.hideMenu();
      }
    }
    setToggled(data, index) {
      if (data.isInActivePath) this.activeIndex.set(index);
    }
    isToggled(index) {
      return this.expandAll() || this.activeIndex() === index;
    }
    static {
      this.ɵfac = function LayoutSidebarMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LayoutSidebarMenuComponent)(i0.ɵɵdirectiveInject(i1.LayoutSidebarService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: LayoutSidebarMenuComponent,
        selectors: [["", "layout-sidebar-menu", ""]],
        hostVars: 8,
        hostBindings: function LayoutSidebarMenuComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("is-root", ctx.root())("is-anchored", ctx.anchored())("is-unanchored", !ctx.anchored())("is-hovering-menu", ctx.hoveringMenu());
          }
        },
        inputs: {
          item: [1, "item"],
          root: [1, "root"],
          visible: [1, "visible"],
          expandAll: [1, "expandAll"],
          reset: [1, "reset"],
          parentActive: [1, "parentActive"]
        },
        attrs: _c0,
        decls: 2,
        vars: 0,
        consts: [[3, "class"], ["role", "menuitem", 3, "href", "ngClass"], ["role", "menuitem", 3, "routerLink", "routerLinkActivePath"], ["role", "menuitem", 3, "click", "href", "ngClass"], [3, "icon", "size"], [1, "fa", "fa-fw", "fa-angle-down", "layout-submenu-toggler"], [1, "icon-right", 3, "icon", "size"], ["role", "menuitem", 3, "click", "routerLink", "routerLinkActivePath"], ["role", "menuitem", 3, "click", "routerLinkActiveState", "routerLink", "routerLinkActivePath"], ["layout-sidebar-menu", "", 3, "item", "visible", "reset", "parentActive", "root"]],
        template: function LayoutSidebarMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, LayoutSidebarMenuComponent_For_1_Template, 2, 2, null, null, i0.ɵɵrepeaterTrackByIdentity);
          }
          if (rf & 2) {
            i0.ɵɵrepeater(ctx.root() ? ctx.item() : ctx.item().items);
          }
        },
        dependencies: [LayoutSidebarMenuComponent, NgClass, UiIconComponent, RouterLink, UiRouterLinkActivePathDirective],
        styles: [".is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%]{width:100%}.is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:var(--sidebarMenuitemTextColor);display:flex;flex-direction:row-reverse;padding:4px 14px;transition:background-color .3s}.is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:after{content:\"\";display:table;clear:both}.is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{align-items:center}.is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]   ui-icon[_ngcontent-%COMP%]:first-child{color:var(--sidebarMenuitemIconColor);background-color:var(--sidebarMenuitemIconBgColor);width:36px;height:36px;line-height:36px;text-align:center}.is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background-color:var(--sidebarMenuitemHoverBgColor);color:var(--sidebarMenuitemHoverTextColor)}.is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover   ui-icon[_ngcontent-%COMP%]{color:var(--sidebarMenuitemHoverIconColor);background-color:var(--sidebarMenuitemHoverIconBgColor)}.is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus:not(.active-menuitem):not(.active-path){background-color:var(--focusColor)!important;border-color:var(--focusColor)!important}body.a11y-emphasize-focus   .is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus:not(.active-menuitem):not(.active-path){transform:scale(1.1)!important}body.a11y-emphasize-focus   .is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus.active-menuitem, body.a11y-emphasize-focus   .is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus.active-path{outline:var(--a11yFocusedElementOutline)!important;outline-offset:-2px!important}.is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{margin-top:9px;display:block;flex:1;overflow:hidden;text-overflow:ellipsis}.is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%]   .menuitem-badge[_ngcontent-%COMP%]{float:right;width:16px;height:16px;margin-right:6px;margin-top:9px;text-align:center;background-color:var(--sidebarMenuitemBadgeBgColor);color:var(--sidebarMenuitemBadgeTextColor);font-size:-1em;font-weight:700;line-height:16px;border-radius:50%}.is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a.active-path[_ngcontent-%COMP%], .is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a.active-menuitem[_ngcontent-%COMP%]{color:var(--sidebarMenuitemActiveTextColor);padding-left:12px;border-left:4px solid var(--sidebarMenuitemBorderColor);background-color:var(--sidebarMenuitemActiveBgColor)}.is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a.active-path[_ngcontent-%COMP%]   ui-icon[_ngcontent-%COMP%]:first-child, .is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a.active-menuitem[_ngcontent-%COMP%]   ui-icon[_ngcontent-%COMP%]:first-child{color:var(--sidebarMenuitemActiveIconColor);background-color:var(--sidebarMenuitemActiveIconBgColor)}.is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a.active-path[_ngcontent-%COMP%]:hover, .is-root[_nghost-%COMP%] > li.menuitem[_ngcontent-%COMP%] > a.active-menuitem[_ngcontent-%COMP%]:hover{background-color:var(--sidebarMenuitemHoverBgColor)}[_nghost-%COMP%]:not(.is-root){list-style-type:none;margin:0;padding:0;overflow:hidden;background-color:var(--sidebarSubMenuitemBgColor);align-items:center}[_nghost-%COMP%]:not(.is-root){border:none}[_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:var(--sidebarMenuitemTextColor);display:flex;padding:4px 14px;position:relative;transition:background-color .3s}[_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:after{content:\"\";display:table;clear:both}[_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{border-left:4px solid var(--sidebarMenuitemBorderColor)}[_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{margin-top:5px;display:block;font-size:.9em;flex:1;overflow:hidden;text-overflow:ellipsis}[_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]   ui-icon[_ngcontent-%COMP%]{color:var(--sidebarSubMenuitemIconColor);background-color:var(--sidebarSubMenuitemIconBgColor);float:left;width:36px;height:28px;line-height:32px;text-align:center;margin-left:-10px}[_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]   ui-icon.icon-right[_ngcontent-%COMP%]{opacity:0;transition:opacity .3s;pointer-events:none;display:block;position:absolute;right:14px}[_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background-color:var(--sidebarSubMenuitemHoverBgColor);color:var(--sidebarSubMenuitemHoverTextColor)}[_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover   ui-icon[_ngcontent-%COMP%]{color:var(--sidebarMenuitemHoverIconColor);background-color:var(--sidebarMenuitemHoverIconBgColor)}[_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus:not(.active-menuitem):not(.active-path){background-color:var(--focusColor)!important;border-color:var(--focusColor)!important}body.a11y-emphasize-focus   [_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus:not(.active-menuitem):not(.active-path){transform:scale(1.1)!important}body.a11y-emphasize-focus   [_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus.active-menuitem, body.a11y-emphasize-focus   [_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus.active-path{outline:var(--a11yFocusedElementOutline)!important;outline-offset:-2px!important}[_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a.active-menuitem[_ngcontent-%COMP%]{color:var(--sidebarSubMenuitemActiveTextColor);font-weight:var(--sidebarSubMenuitemActiveFontWeight, 400);border-left:4px solid var(--sidebarSubMenuitemActiveTextColor);background-color:var(--sidebarSubMenuitemActiveBgColor)}[_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a.active-menuitem[_ngcontent-%COMP%]   ui-icon[_ngcontent-%COMP%]{color:var(--sidebarSubMenuitemActiveIconColor);background-color:var(--sidebarSubMenuitemActiveIconBgColor)}[_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a.active-menuitem[_ngcontent-%COMP%]:hover{background-color:var(--sidebarSubMenuitemHoverBgColor);color:var(--sidebarSubMenuitemHoverTextColor)}[_nghost-%COMP%]:not(.is-root) > li.menuitem[_ngcontent-%COMP%] > a.active-menuitem[_ngcontent-%COMP%]:hover   ui-icon[_ngcontent-%COMP%]{color:var(--sidebarMenuitemHoverIconColor);background-color:var(--sidebarMenuitemHoverIconBgColor)}.is-unanchored[_nghost-%COMP%]:not(.is-root):not(.is-hovering-menu) > li.menuitem[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]   ui-icon.icon-right[_ngcontent-%COMP%]{opacity:1}.a11y-no-distraction-mode[_nghost-%COMP%]   ui-icon[_ngcontent-%COMP%], .a11y-no-distraction-mode   [_nghost-%COMP%]   ui-icon[_ngcontent-%COMP%]{display:none}"],
        data: {
          animation: [trigger('children', [state('hiddenAnimated', style({
            height: '0px'
          })), state('visibleAnimated', style({
            height: '*'
          })), state('visible', style({
            height: '*',
            'z-index': 100
          })), state('hidden', style({
            height: '0px',
            'z-index': '*'
          })), transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')), transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))])]
        },
        changeDetection: 0
      });
    }
  }
  return LayoutSidebarMenuComponent;
})();